var ValidationError = Backbone.Model.extend({

    defaults: {
        type: '',
        message: '',
        code: 0,
        belongsTo: ''
    }

});

export default ValidationError;
